export const environment = {
    production: true,
    apiBaseUrl: 'https://uv2okg9325.execute-api.us-east-1.amazonaws.com/dev',
    apiPurchaseUrl: 'https://qxtkufuq3c.execute-api.us-east-1.amazonaws.com/default/',
    apiTokenPresignUrl: 'https://mpwkiyvm3d.execute-api.us-east-1.amazonaws.com/default/token',
    apiPresignUrl: 'https://mpwkiyvm3d.execute-api.us-east-1.amazonaws.com/default/upload',
    apiPresignURlUploadStatus: 'https://uv2okg9325.execute-api.us-east-1.amazonaws.com/dev/factura/status-carga'
};
